import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/Home.vue')
  },
  {
    path: '/ai',
    name: 'AI',
    component: () => import('@/views/AI.vue')
  },
  {
    path: '/data-service',
    name: 'DataService',
    component: () => import('@/views/DataService.vue')
  },
  {
    path: '/tech-consult',
    name: 'TechConsult',
    component: () => import('@/views/TechConsult.vue')
  },
  {
    path: '/llm',
    name: 'LLM',
    component: () => import('@/views/LLM.vue')
  },
  {
    path: '/data-platform',
    name: 'DataPlatform',
    component: () => import('@/views/DataPlatform.vue')
  },
  {
    path: '/lowcode',
    name: 'LowCode',
    component: () => import('@/views/LowCode.vue')
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 如果有保存的位置（比如使用浏览器的后退按钮），则恢复到该位置
    if (savedPosition) {
      return savedPosition
    }
    // 否则滚动到顶部
    return { top: 0 }
  }
})

export default router